// Изменения протокола после ревизии (015: contracts/api.md, «ProtocolChanges»; research, Р1, Р2;
// ADR-0032, «Канал обновлений»). Экран читает их раз в 2 секунды, пока вкладка видна; фоновый
// запрос сеанс не продлевает. Присутствие — подсказка «В сети», не блокировка (COLLAB-14).
import { z } from '../kernel/zod.ts';
import { DateSchema, IdSchema } from '../kernel/common.ts';
import { ProtocolAccessSchema } from './access.ts';
import { ItemRowSchema } from './item.ts';
import { ProtocolColumnSchema } from './protocol.ts';

/** Сколько пользователей «В сети» отдаёт ответ (свой — первым). */
export const PRESENCE_LIMIT = 50;
/** Пользователь «В сети», если читал изменения протокола не позже стольких секунд назад. */
export const PRESENCE_WINDOW_SECONDS = 30;

export const ChangesQuerySchema = z.strictObject({
  since: z.coerce.number().int().min(0),
  /** Ключ прав, которые знает экран (020: research, Р6): права в ответе — только при другом. */
  access: z.string().max(128).optional(),
});

export const PresenceUserSchema = z.object({ userId: IdSchema, name: z.string() });
export type PresenceUser = z.infer<typeof PresenceUserSchema>;

export const ProtocolChangesSchema = z.object({
  revision: z.number().int().min(1),
  structureRevision: z.number().int().min(1),
  transferRevision: z.number().int().min(1),
  mode: z.enum(['active', 'reverted']),
  /** Сменилось поколение (новый перевод) или режим: пунктов нет, экран перечитывает состояние. */
  reset: z.boolean(),
  /** Пункты текущего поколения с updatedRevision > since, включая архивные. */
  items: z.array(ItemRowSchema),
  /** Колонки протокола, если менялись после since; иначе null. */
  columns: z.array(ProtocolColumnSchema).nullable(),
  presence: z.array(PresenceUserSchema).max(PRESENCE_LIMIT),
  today: DateSchema,
  /**
   * Рабочая неделя и число снимков (016): фиксация другим пользователем сдвигает неделю — экран
   * узнаёт об этом опросом, без перечитывания состояния.
   */
  weekDate: DateSchema,
  snapshotCount: z.number().int().min(0),
  /** Права пользователя, если ключ отличается от `access` запроса; иначе null (020). */
  access: ProtocolAccessSchema.nullable(),
});
export type ProtocolChanges = z.infer<typeof ProtocolChangesSchema>;
